var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScissor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.421,48L67.72,31.701c0.781-0.781,0.781-2.047,0-2.828c-0.781-0.781-2.047-0.781-2.828,0L48.592,45.172L42.59,39.17 c0.706-1.192,1.118-2.578,1.118-4.061c0-4.415-3.592-8.007-8.007-8.007s-8.007,3.592-8.007,8.007s3.592,8.007,8.007,8.007 c1.483,0,2.868-0.413,4.061-1.118L45.764,48l-6.002,6.002c-1.192-0.706-2.578-1.118-4.061-1.118c-4.415,0-8.007,3.592-8.007,8.007 s3.592,8.007,8.007,8.007s8.007-3.592,8.007-8.007c0-1.483-0.413-2.868-1.118-4.061l6.002-6.002l16.299,16.299 c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586c0.781-0.781,0.781-2.047,0-2.828L51.421,48z M31.695,35.109 c0-2.209,1.797-4.007,4.007-4.007s4.007,1.797,4.007,4.007s-1.797,4.007-4.007,4.007S31.695,37.319,31.695,35.109z M35.702,64.897 c-2.209,0-4.007-1.798-4.007-4.007s1.797-4.007,4.007-4.007s4.007,1.798,4.007,4.007S37.911,64.897,35.702,64.897z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissor);
export default __webpack_public_path__ + "static/media/scissor.6a574d2e45fd7aecc81afbafea17b96e.svg";
export { ForwardRef as ReactComponent };